import React from 'react'

import { connect } from 'react-redux'

// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'

import { setSidebarToggleMobile } from '../../reducers/ThemeOptions'

import { SidebarHeader, SidebarMenu } from '@/layout-components'
import SidebarFooter from '@/layout-components/SidebarFooter'
import withSession from '@/housefolios-components/Session/withSession'
import { useQuery } from "@apollo/client/react";
import RenewSession from '@/housefolios-components/Session/RenewSession'
import useNewMessageSubscription from '@/hooks/useNewMessageSubscription'
import useAffiliate from '@/hooks/useAffiliate'
import { Backdrop, CircularProgress, Drawer, Box } from '@mui/material'
import { drawerRootSx } from '@/layout-blueprints/chromeSx'
import useDesktopNav from '@/layout-blueprints/useDesktopNav'
import {
  loadingBackdropSx,
  sidebarPaperSx,
  sidebarContentSx,
} from '@/layout-blueprints/chromeComponentSx'

const Sidebar = (props) => {
  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile)
  }

  const {
    sidebarStyle,
    sidebarShadow,
    sidebarFooter,
    sidebarToggleMobile,
    setSidebarToggleMobile,
    setOpenFeedbackTour,
    sidebarToggle,
  } = props

  let isMember = false

  const [{ affiliate, affiliateLoading, urlAffiliate }] =
    useAffiliate({
      memberValue: props?.session?.me?.activeOrg?.member,
    })

  useNewMessageSubscription(props?.session?.me?._id, ['admin'], true)

  const isDesktop = useDesktopNav()

  if (!affiliateLoading) {
    if (isEmpty(affiliate)) isMember = false
    else {
      isMember = true
    }
  }

  if (affiliateLoading)
    return (
      <Backdrop open={true} sx={loadingBackdropSx}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )

  const drawerContent = (
    <>
      <SidebarHeader
        affiliate={affiliate}
        collapsed={props.collapsed}
      />
      <Box sx={sidebarContentSx} data-hf="sidebar-content">
        <SidebarMenu
          affiliate={affiliate}
          setOpenFeedbackTour={setOpenFeedbackTour}
        />
      </Box>
      {isMember && sidebarFooter && !urlAffiliate && (
        <SidebarFooter />
      )}
    </>
  )

  return (
    <>
      <Drawer
        variant={isDesktop ? 'permanent' : 'temporary'}
        open={isDesktop ? true : sidebarToggleMobile}
        onClose={toggleSidebarMobile}
        anchor="left"
        ModalProps={{ keepMounted: true }}
        sx={drawerRootSx({
          collapsed: sidebarToggle,
          isDesktop,
        })}
        slotProps={{
          paper: {
            'data-hf': 'chrome-sidebar',
            sx: sidebarPaperSx({
              collapsed: sidebarToggle,
              shadow: sidebarShadow,
              isDark: String(sidebarStyle || '').includes('dark'),
            }),
          },
        }}
      >
        {drawerContent}
      </Drawer>
      <RenewSession />
    </>
  )
}

const mapStateToProps = (state) => ({
  sidebarShadow: state.DeprecatedThemeOptions.sidebarShadow,
  sidebarFooter: state.DeprecatedThemeOptions.sidebarFooter,
  sidebarStyle: state.DeprecatedThemeOptions.sidebarStyle,
  sidebarToggleMobile:
    state.DeprecatedThemeOptions.sidebarToggleMobile,
  sidebarToggle: state.DeprecatedThemeOptions.sidebarToggle,
})

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) =>
    dispatch(setSidebarToggleMobile(enable)),
})

export default withSession(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar),
)
